import ProjectScopeDocViewModule from './scope-doc-view.module'

export default ProjectScopeDocViewModule
